<div class="arrow-container">
    <div class="block">
        <div>
            <h1>Uitloggen</h1>
            <h2>Aan het uitloggen...</h2>
        </div>
    </div>
</div>

